import RoutePath from 'components/RoutePath'
import ClockIcon from 'components/icons/ClockIcon'
import LeftArrow from 'components/icons/LeftArrow'
import DriveRight from 'modules/Exp-Candidates/ViewDrive/DriveRightPart/index'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import DriveDetail from '../../Exp-Candidates/ViewDrive/DriveDetails/index'

import { DriveTitle } from 'modules/Drives/ViewDrive/DriveDetails/style'
import DownlaodUpload from 'modules/Exp-Candidates/DownloadAndUpload/index'
import AddInterviewer from 'modules/Exp-Candidates/ViewDrive/AddInterviewerDrawer/index'
import DriveTimeDrawer from 'modules/Exp-Candidates/ViewDrive/DriveTimeDrawer/index'
import {
  ClockButtonDiv,
  ClockDiv,
  DrivInfoDiv,
  DriveDetailDiv,
  LeftSection,
  PaddedDiv,
  SectinFlex,
  SectionName,
  TopEndFlex,
  TopHeader,
} from 'modules/Exp-Candidates/ViewDrive/Style/style'
import { useSelector } from 'react-redux'
import { permittedSubEvents } from '../../../utils/permissionsValidation'

const ViewDriveRole = ({
  driveMetricsData,
  driveRolesMetrics,
  getIndidualDriveMetrics,
  getDriveRoleMetrics,
  getIndidualDriveData,
  driveData,
  getInterviewerList,
  getDriveInterviewerList,
  updateInterview,
  interViewerList,
  driveInterViewerList,
  addInterviewer,
  deleteInterviewer,
  getUserRoles,
  addTimeBreak,
}) => {
  const params = useParams()
  const [addInterviewerDrawer, setAddInterviewerDrawer] = useState(false)
  const [driveTime, setDriveTime] = useState(false)
  const [disable, setDisable] = useState(false)
  const [addReplaceDrawer, setAddReplaceDrawer] = useState(false)
  const roleName = driveRolesMetrics

  useEffect(() => {
    getIndidualDriveMetrics(params?.expcandidatesId)
    getDriveRoleMetrics(params?.expcandidatesId)
    getIndidualDriveData(params.roleId)
    getDriveInterviewerList(params?.expcandidatesId)
  }, [params])

  useEffect(() => {
    setDisable(false)
    if (
      driveData?.driveMode === 'VIRTUAL_DRIVE' &&
      driveData?.corporateStatus === 'CANCELLED'
    ) {
      setDisable(true)
    }
  }, [driveData])

  useEffect(() => {
    getUserRoles()
  }, [])

  const permission = useSelector(state => state?.auth?.permissions)
  const subEvents = permittedSubEvents(
    permission,
    'Evaluation Process - Experienced Candidate',
    'Drive Info'
  )
  return (
    <>
      <PaddedDiv column>
        <TopHeader row spaceBetween alignCenter>
          <LeftSection centerVertically>
            <Link to={`/expcandidatedrive/${params?.roleId}`}>
              <LeftArrow />
            </Link>
            <SectionName column>
              <RoutePath
                from="Experienced Candidate"
                on={roleName[0]?.roleName}
                path={`/expcandidatedrive/${params?.roleId}`}
              />
              {}
              <DriveTitle>Role View</DriveTitle>
              {}
            </SectionName>
          </LeftSection>
          <TopEndFlex alignCenter>
            <ClockButtonDiv>
              {disable ? (
                <ClockDiv>
                  <ClockIcon />
                </ClockDiv>
              ) : (
                <ClockDiv onClick={() => setDriveTime(true)}>
                  <ClockIcon />
                </ClockDiv>
              )}
              {subEvents?.includes('DOWNLOAD/UPLOAD') && (
                <DownlaodUpload
                  driveId={params?.expcandidatesId}
                  noNeedRole={false}
                  driveData={driveData}
                />
              )}
            </ClockButtonDiv>
          </TopEndFlex>
        </TopHeader>
        <SectinFlex>
          <DriveDetailDiv>
            <DriveDetail
              driveMetricsData={driveMetricsData}
              driveRolesMetrics={driveRolesMetrics}
              driveData={driveData}
            />
          </DriveDetailDiv>
          <DrivInfoDiv>
            <DriveRight
              driveData={driveData}
              setDriveTime={setDriveTime}
              driveRolesMetrics={driveRolesMetrics}
            />
          </DrivInfoDiv>
        </SectinFlex>
      </PaddedDiv>
      {addInterviewerDrawer && (
        <AddInterviewer
          addInterviewerDrawer={addInterviewerDrawer}
          setAddInterviewerDrawer={setAddInterviewerDrawer}
          getInterviewerList={getInterviewerList}
          getDriveInterviewerList={getDriveInterviewerList}
          interViewerList={interViewerList}
          driveInterViewerList={driveInterViewerList}
          driveId={params?.expcandidatesId}
          addInterviewer={addInterviewer}
          deleteInterviewer={deleteInterviewer}
          setAddReplaceDrawer={setAddReplaceDrawer}
          addReplaceDrawer={addReplaceDrawer}
          updateInterview={updateInterview}
        />
      )}

      {driveTime && (
        <DriveTimeDrawer
          driveTime={driveTime}
          setDriveTime={setDriveTime}
          addTimeBreak={addTimeBreak}
          driveId={params?.expcandidatesId}
          driveData={driveData}
          getIndidualDriveData={getIndidualDriveData}
        />
      )}
    </>
  )
}

export default ViewDriveRole
